<template>
  <div class="chat-widget " v-if="chatStatus">

    <div class="rounded-pill badge chat-widget-unread-chats" v-if="un_read_chats > 0">
      {{ un_read_chats }}
    </div>

    <div class="chat-widget--bubble -hide">


      <div class="" v-if="showList  && checkChatToken()">
        <div class="text-right">
          <div class="btn btn-sm my-2 rounded-pill btn-primary" @click="createChat">
            ساخت چت
            <i class="bi bi-plus-circle-fill"></i>
          </div>
        </div>

        <chat-archive1 @rawChatData="rawChatData" @selectedChat="setUserChat"/>

      </div>
      <div class="" v-else>
        <div class="text-left" v-if=" checkChatToken()">
          <div class="btn " @click="showList=!showList ">
            بازگشت
            <i class="bi bi-arrow-left-circle-fill"></i>
          </div>
        </div>
        <m-chat-layout class="m-0" @startNewChat="startNewChat" :slug="slug"/>
      </div>

    </div>

    <a @click="openChatModal()" :class="`${enableAnimation  ? 'chat-widget-button-animation' : '' }`"
       class="chat-widget--button btn btn-primary">
     <slot>
       <i class="bi bi-messenger p-0 m-0 h3"></i>
     </slot>
    </a>
  </div>
</template>

<script>
import mChatLayout from "../Layout/ChatLayout1/ChatLayout";
import ChatArchive1 from "../../Chat/Archive/ChatArchive1.vue";
import {mapGetters} from "vuex";

export default {
  name: "ChatWidget1",
  components: {ChatArchive1, mChatLayout},
  props: {
    enableAnimation: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      slug: null,
      showList: true,
      un_read_chats: 0,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated'
    }),
    chatStatus() {
      return this.findAttributeOnSiteInfo('chat_activity')[0] == 1
    },

  },
  methods: {
    getChatSlugFromLocalStorage() {
      const slug = localStorage.getItem('chat_slug')
      this.slug = slug != undefined ? slug : null
    },
    startNewChat(res) {
      res = res.data.data
      const chatToken = res.chat_token;
      const slug = res.data.slug;
      localStorage.setItem('chat_token', chatToken)
      localStorage.setItem('chat_slug', slug)
      this.slug = slug
    },
    openChatModal() {
      var chatBubble = document.querySelector('.chat-widget--bubble');

      void chatBubble.offsetWidth;
      chatBubble.classList.toggle('-hide');

    },
    setUserChat(chat) {
      localStorage.setItem('chat_slug', chat.slug)
      this.slug = chat.slug
      this.showList = !this.showList
    },
    createChat() {
      localStorage.removeItem('chat_token')
      localStorage.removeItem('chat_slug')
      this.slug = null
      this.showList = !this.showList
    },
    checkChatToken() {
      let chatToken = localStorage.getItem('chat_token')

      if (this.isAuthenticated) {
        return true
      }
      if (chatToken === null) {
        return false
      }

      return true
    },
    rawChatData(data) {
      this.un_read_chats = data.un_read_chats
    }
  },
  mounted() {
    if (this.chatStatus) {
      this.getChatSlugFromLocalStorage()
    }
  }
}
</script>

<style scoped>
@-webkit-keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 199, 177, 0.4);
  }
  75%, 100% {
    box-shadow: 0 0 0 2rem rgba(0, 199, 177, 0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(0, 199, 177, 0.4);
  }
  75%, 100% {
    box-shadow: 0 0 0 2rem rgba(0, 199, 177, 0);
  }
}


.chat-widget--button {
  cursor: pointer;
}

button {
  padding: 0 1rem;
  color: #6376ec;
  border: 1px solid #6376ec;
  border-radius: 4px;
  line-height: 2rem;
  background-color: transparent;
  transition: background-color 350ms ease, color 350ms ease;
}


.chat-widget {
  position: fixed;
  right: 7px;
  bottom: 2rem;
  z-index: 1031;
}

.chat-widget--bubble {
  display: block;
  min-width: 310px;
  height: 350px;
  overflow: auto;
  position: absolute;
  right: 0;
  bottom: 5rem;
  background-color: #f6f6f6;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transform-origin: 90% 100%;
  transition: opacity 400ms ease, transform 400ms ease;
  opacity: 1;
  transform: translateY(0rem) scale(1, 1) skew(0deg, 0deg);
}

.chat-widget--bubble.-hide {
  opacity: 0;
  transform: translateY(3rem) scale(0, 0) skew(0deg, 50deg);
}

.chat-widget--bubble > * + * {
  margin-top: 1rem;
}

.chat-widget--button:hover {
  border: none;
}

.chat-widget--button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 4.5rem;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 1;
  border-radius: 50%;
  box-shadow: 0 0 0 -2px black, 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  transition: box-shadow 250ms ease;
}

.chat-widget-button-animation {
  -webkit-animation: shadow-pulse 1.5s infinite;
  animation: shadow-pulse 1.5s infinite;
}


@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 18px rgba(0, 0, 0, 0);
  }
}

.chat-widget-unread-chats {
  z-index: 20;
  position: relative;
  background: var(--secondary);
}

</style>